import { NivosMainLayout, NivosPublicLayout } from '../layouts'
import { NivosRoutes, PublicRoutes } from './router'
import { Box } from '@mui/material'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Authenticator from 'components/nivos/authenticator'

const Nivos: React.FC = () => {
  return (
    <Box>
      <Routes>
        {NivosRoutes.map((routeProps, index) => (
          <Route
            key={index}
            path={routeProps.path}
            element={
              <Authenticator>
                <NivosMainLayout>{routeProps.element}</NivosMainLayout>
              </Authenticator>
            }
          />
        ))}
        {PublicRoutes.map((routeProps, index) => (
          <Route
            key={index}
            path={routeProps.path}
            element={
              <NivosPublicLayout>{routeProps.element}</NivosPublicLayout>
            }
          />
        ))}
      </Routes>
    </Box>
  )
}

export default Nivos
